export default __webpack_public_path__ + "static/360-5c9e443d3ff65941f05bbf599f3dab4d.jpg";